/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Teams_Create_Is_Default_TeamInputs */

const en_forms_teams_create_is_default_team = /** @type {(inputs: Forms_Teams_Create_Is_Default_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is Default Team`)
};

const de_forms_teams_create_is_default_team = /** @type {(inputs: Forms_Teams_Create_Is_Default_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist Standard Team`)
};

/**
* | output |
* | --- |
* | "Is Default Team" |
*
* @param {Forms_Teams_Create_Is_Default_TeamInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_teams_create_is_default_team = /** @type {((inputs?: Forms_Teams_Create_Is_Default_TeamInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Teams_Create_Is_Default_TeamInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_teams_create_is_default_team(inputs)
	return de_forms_teams_create_is_default_team(inputs)
});